import React, { useState } from "react";
import ImageBanner from "@/components/ImageBanner";
import Footer from "@/layout/Footer";

const ForgotPassword = () => {
	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="Email Verify"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>
			<div className="flex justify-center mt-[28px] h-[700px] hidden lg:flex">
				<div className="w-[361px] h-auto flex flex-col gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					<div className="font-[Montserrat] font-medium text-[13px] leading-[100%] tracking-[0%] text-center">
						Check your email & click the link
						<br />
						to activate your account.
					</div>

					{/* Email Input */}
					<input
						type="text"
						placeholder="Email"
						className="w-[321px] h-[33px] rounded-[8px] border border-[#193D34] p-[8px] outline-none"
					/>

					<div className="w-[135px] h-[82px] flex flex-col items-center justify-center mx-auto gap-[16px]">
						<button className="w-[185px] h-[32px] flex items-center justify-center rounded-[24px] p-[8px] bg-[#B7D974] text-[#193D34] text-[13px] font-[500] font-montserrat leading-[24px] text-center">
							Send Request
						</button>

						<p className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34] cursor-pointer">
							Contact Support
						</p>
					</div>
				</div>
			</div>
			{/* Mobile View  */}
			<ImageBanner type="mobile" title="Email Verify" />
			<div className="flex justify-center mt-[28px] h-[490px] lg:hidden">
				<div className="w-[95%] max-w-[361px] flex flex-col gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					<div className="font-[Montserrat] font-medium text-[13px] leading-[100%] tracking-[0%] text-center">
						Check your email & click the link
						<br />
						to activate your account.
					</div>
					{/* Email Input */}
					<input
						type="text"
						placeholder="Email"
						className="w-full h-[33px] rounded-[8px] border border-[#193D34] p-[8px] outline-none"
					/>

					<div className="w-full flex flex-col items-center justify-center gap-[16px]">
						<button className="flex items-center justify-center w-[185px] h-[32px] rounded-[24px] p-[8px] bg-[#B7D974] text-[#193D34] text-[13px] font-[500] font-montserrat leading-[24px] text-center">
							Send Request
						</button>
						<p className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34] cursor-pointer">
							Contact Support
						</p>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default ForgotPassword;
